import * as React from "react";
import { css } from "@emotion/core";
import { Tabs, Tab } from "@blueprintjs/core";
import AnnotationTable from "./AnnotationsTable";

interface SheetTabsProps {
  data: any;
}

const SheetTabs = ({ data }: SheetTabsProps) => {
  const [selectedSheet, setSelectedSheet] = React.useState(null);

  const currentSheet = React.useMemo(
    () => data.find((d: { id: number }) => d.id === selectedSheet),
    [data, selectedSheet]
  );

  React.useEffect(() => {
    if (data && data.length > 0) {
      setSelectedSheet(data[0].id);
    }
  }, [data]);

  if (!currentSheet) return null;

  return (
    <div
      css={css`
        display: flex;
        flex-direction: column;
        flex-grow: 1;
        overflow: hidden;
      `}
    >
      <Tabs
        id="ExportSpreadsheet"
        onChange={setSelectedSheet}
        selectedTabId={selectedSheet}
        css={css`
          padding: 0 1rem;
        `}
      >
        {data.map((sheet: { id: number; layer: string; rows: any[] }) => (
          <Tab
            key={sheet.id}
            id={sheet.id}
            title={`${sheet.layer} (${sheet.rows.length})`}
            panel={null}
          />
        ))}
      </Tabs>

      <div
        css={css`
          flex-grow: 1;
          overflow: hidden;
        `}
      >
        <AnnotationTable
          key={currentSheet.id}
          headers={currentSheet.headers}
          rows={currentSheet.rows}
        />
      </div>
    </div>
  );
};

export default SheetTabs;
